const SELECTOR_CAROUSEL = '.js-heroV3Carousel';
const SELECTOR_PAGINATION = '.js-heroV3Pag';

const waitForSwiper = (timeoutMs = 5000) => new Promise((resolve, reject) => {
  if (window.Swiper) return resolve(window.Swiper);
  const start = Date.now();
  const id = setInterval(() => {
    if (window.Swiper) {
      clearInterval(id);
      resolve(window.Swiper);
    } else if (Date.now() - start > timeoutMs) {
      clearInterval(id);
      reject(new Error('Swiper failed to load within timeout.'));
    }
  }, 50);
});

class HeroV3Carousel extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this._onSectionChange = this._onSectionChange.bind(this);
  }

  connectedCallback() {
    this.init();
    document.addEventListener('shopify:section:load', this._onSectionChange);
    document.addEventListener('shopify:section:unload', this._onSectionChange);
  }

  disconnectedCallback() {
    this.destroy();
    document.removeEventListener('shopify:section:load', this._onSectionChange);
    document.removeEventListener('shopify:section:unload', this._onSectionChange);
  }

  _onSectionChange(evt) {
    const target = evt && evt.target;
    if (!target || typeof target.querySelector !== 'function') return;
    if (target.querySelector('[data-component="heroV3Carousel"]')) {
      this.destroy();
      this.init();
    }
  }

  _parseAutoplay(value) {
    if (!value) return false;
    try {
      return JSON.parse(value);
    } catch (e) {
      return false;
    }
  }

  async init() {
    const elCarousel = this.querySelector(SELECTOR_CAROUSEL);
    if (!elCarousel) return;
    if (elCarousel.classList.contains('swiper-initialized')) return;

    let Swiper;
    try {
      Swiper = await waitForSwiper();
    } catch (err) {
      console.warn('[hero-v3]', err.message);
      return;
    }

    if (elCarousel.classList.contains('swiper-initialized')) return;

    const slides = elCarousel.querySelectorAll('.swiper-slide');
    if (slides.length < 2) return;

    const paginationEl = this.querySelector(SELECTOR_PAGINATION);
    const loop = elCarousel.dataset.loop !== 'false';
    const autoplay = this._parseAutoplay(elCarousel.dataset.autoplay);
    if (autoplay) {
      autoplay.disableOnInteraction = false;
      if (!loop) autoplay.stopOnLastSlide = true;
    }

    this.swiper = new Swiper(elCarousel, {
      loop: loop,
      speed: 600,
      autoplay: autoplay,
      pagination: paginationEl ? { el: paginationEl, clickable: true } : false,
      updateOnImagesReady: true,
    });

    const warmSlideImages = () => {
      elCarousel.querySelectorAll('.swiper-slide img').forEach((img) => {
        if (img.complete) return;
        img.loading = 'eager';
      });
    };
    if (document.readyState === 'complete') {
      warmSlideImages();
    } else {
      window.addEventListener('load', warmSlideImages, { once: true });
    }
  }

  destroy() {
    if (this.swiper && typeof this.swiper.destroy === 'function') {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

if (!customElements.get('hero-v3-carousel')) {
  customElements.define('hero-v3-carousel', HeroV3Carousel);
}
